import { render, staticRenderFns } from "./MeshTree.vue?vue&type=template&id=0e4d2ae4&scoped=true"
import script from "./MeshTree.vue?vue&type=script&lang=js"
export * from "./MeshTree.vue?vue&type=script&lang=js"
import style0 from "./MeshTree.vue?vue&type=style&index=0&id=0e4d2ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d2ae4",
  null
  
)

export default component.exports